<template>
  <div v-show="!loading" class="mswcreators">
    <div id="hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')" class="mswcreators__hero">
      <div class="mswcreators__hero__logo"></div>
      <h1 class="mswcreators__hero__description">
        MapleStory Worlds Creators Workshop is a 12-week incubator program for emerging game designers and game
        development teams brought to you by Nexon America and MapleStory Worlds. This is your chance to flex your game
        design skills, meet other awesome creators like yourself, and publish your game in MapleStory Worlds with direct
        support from Nexon.

        <div>Applications are open now and will close on August 24.</div>
      </h1>
    </div>

    <div id="navbar" class="mswcreators__navbar">
      <ApplyBtn />
      <div
        class="mswcreators__navbar__item"
        :class="{ active: activeMenuIndex === 0 }"
        @click="
          () => {
            scrollToId('program-overview', 'Program Overview')
          }
        "
      >
        Program Overview
      </div>
      <div
        class="mswcreators__navbar__item"
        :class="{ active: activeMenuIndex === 1 }"
        @click="
          () => {
            scrollToId('curriculum', 'Curriculum')
          }
        "
      >
        Curriculum
      </div>
      <div
        class="mswcreators__navbar__item"
        :class="{ active: activeMenuIndex === 2 }"
        @click="
          () => {
            scrollToId('creator-workshop-alumni', 'Creator Workshop Alumni')
          }
        "
      >
        Creator Workshop Alumni
      </div>
      <div
        class="mswcreators__navbar__item"
        :class="{ active: activeMenuIndex === 3 }"
        @click="
          () => {
            scrollToId('faq', 'FAQ')
          }
        "
      >
        FAQ
      </div>
      <a
        :href="mswSite"
        target="_blank"
        class="mswcreators__navbar__item mswcreators__navbar__item--link"
        @click="
          navLinkClicked({
            interaction: 'menu_click',
            sectionNumber: 0,
            sectionName: 'Header',
            sectionContent: 'MSW Website',
          })
        "
        @click.middle="
          navLinkClicked({
            interaction: 'menu_click',
            sectionNumber: 0,
            sectionName: 'Header',
            sectionContent: 'MSW Website',
          })
        "
        >MSW Website</a
      >
      <div ref="refNav" class="mswcreators__navbar__after" />
    </div>

    <div class="mswcreators__content">
      <div
        id="program-overview"
        v-observe-visibility="observeVisibilitySettings(1, 'Program Overview')"
        data-section-number="1"
        class="mswcreators__content__program"
      >
        <div class="mswcreators__content__program__title">Program Overview</div>
        <ApplyBtn class="mswcreators__content__program__apply" />
        <div class="mswcreators__content__program__boxes">
          <div v-for="(item, index) in programKeys" :key="index" class="mswcreators__content__program__boxes__box">
            <div class="mswcreators__content__program__key" :class="{ active: item.showDetails }">
              <div class="mswcreators__content__program__key__content">
                <div class="mswcreators__content__program__key__content__title">
                  {{ item.title }}
                </div>
                <div class="mswcreators__content__program__key__content__button">
                  <span
                    class="mswcreators__content__program__key__content__button__icon"
                    @click="
                      () => {
                        item.showDetails = !item.showDetails
                        item.showDetails
                          ? clickTracking({
                              interaction: 'content_view',
                              sectionNumber: 1,
                              sectionName: 'Program Overview',
                              sectionContent: item.title,
                            })
                          : ''
                      }
                    "
                  ></span>
                </div>
                <div class="mswcreators__content__program__key__content__details">
                  {{ item.details }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mswcreators__content__program__dates">
          <div class="mswcreators__content__program__dates__title">Key Dates</div>

          <div class="mswcreators__content__program__dates__date">
            <div class="mswcreators__content__program__dates__date__day">July 21</div>
            <div class="mswcreators__content__program__dates__date__info">Open Applications</div>
          </div>

          <div class="mswcreators__content__program__dates__date">
            <div class="mswcreators__content__program__dates__date__day">Aug 24</div>
            <div class="mswcreators__content__program__dates__date__info">Close Applications</div>
          </div>

          <div class="mswcreators__content__program__dates__date">
            <div class="mswcreators__content__program__dates__date__day">Sep 1</div>
            <div class="mswcreators__content__program__dates__date__info">Applicants Notified</div>
          </div>

          <div class="mswcreators__content__program__dates__date">
            <div class="mswcreators__content__program__dates__date__day">Sep 15</div>
            <div class="mswcreators__content__program__dates__date__info">Workshop Begins</div>
          </div>

          <div class="mswcreators__content__program__dates__date">
            <div class="mswcreators__content__program__dates__date__day">Dec 12</div>
            <div class="mswcreators__content__program__dates__date__info">Workshop Ends</div>
          </div>
        </div>
      </div>

      <div
        id="curriculum"
        v-observe-visibility="observeVisibilitySettings(2, 'Curriculum')"
        data-section-number="2"
        class="mswcreators__content__curriculum"
      >
        <div class="mswcreators__content__curriculum__title">Curriculum</div>
        <ApplyBtn class="mswcreators__content__curriculum__apply" />
        <div class="mswcreators__content__curriculum__animation"></div>

        <div class="mswcreators__content__curriculum__steps">
          <div class="mswcreators__content__curriculum__steps__step-container">
            <div
              class="mswcreators__content__curriculum__steps__step-container__step mswcreators__content__curriculum__steps__step-container__step--1"
            >
              <div class="mswcreators__content__curriculum__steps__step-container__step__left">
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__title">STEP</div>
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__subtitle">
                  Project Updates
                </div>
              </div>
              <div class="mswcreators__content__curriculum__steps__step-container__step__description">
                Submit weekly updates on your project pitch, design and development progress.
              </div>
            </div>
          </div>
          <div class="mswcreators__content__curriculum__steps__step-container">
            <div
              class="mswcreators__content__curriculum__steps__step-container__step mswcreators__content__curriculum__steps__step-container__step--2"
            >
              <div class="mswcreators__content__curriculum__steps__step-container__step__left">
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__title">STEP</div>
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__subtitle">
                  Roundtable Reviews
                </div>
              </div>
              <div class="mswcreators__content__curriculum__steps__step-container__step__description">
                Collect feedback from other program participants in weekly small group workshop sessions.
              </div>
            </div>
          </div>
          <div class="mswcreators__content__curriculum__steps__step-container">
            <div
              class="mswcreators__content__curriculum__steps__step-container__step mswcreators__content__curriculum__steps__step-container__step--3"
            >
              <div class="mswcreators__content__curriculum__steps__step-container__step__left">
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__title">STEP</div>
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__subtitle">
                  Business Guidance
                </div>
              </div>
              <div class="mswcreators__content__curriculum__steps__step-container__step__description">
                Advance your career evolution while promoting your overall well-being with 1:1 career coaching sessions
                from HealthyGamer.
              </div>
            </div>
          </div>
          <div class="mswcreators__content__curriculum__steps__step-container">
            <div
              class="mswcreators__content__curriculum__steps__step-container__step mswcreators__content__curriculum__steps__step-container__step--4"
            >
              <div class="mswcreators__content__curriculum__steps__step-container__step__left">
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__title">STEP</div>
                <div class="mswcreators__content__curriculum__steps__step-container__step__left__subtitle">
                  Publishing
                </div>
              </div>
              <div class="mswcreators__content__curriculum__steps__step-container__step__description">
                Distribute your game worldwide through MapleStory Worlds with support from Nexon.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="creator-workshop-alumni"
        v-observe-visibility="observeVisibilitySettings(3, 'Creator Workshop Alumni')"
        data-section-number="3"
        class="mswcreators__contents__creator"
      >
        <div class="title">Creator Workshop Alumni</div>
        <div class="contents">
          <div
            v-for="alumni in creatorWorkshopAlumni"
            :key="alumni.title"
            class="thumbnail-frame"
            @click="openAlumniDialog(alumni)"
          >
            <img :src="getAlumniImageSrc(alumni.title)" :alt="alumni.title" />
          </div>
        </div>
      </div>

      <div
        id="faq"
        v-observe-visibility="observeVisibilitySettings(4, 'FAQ')"
        data-section-number="4"
        class="mswcreators__content__faq"
      >
        <div class="mswcreators__content__faq__title">Frequently Asked Questions</div>

        <div class="mswcreators__content__faq__image"></div>

        <div class="mswcreators__content__faq__content">
          <div v-for="(faq, index) in faqs" :key="faq.title" class="mswcreators__content__faq__content__item">
            <div class="mswcreators__content__faq__content__item__title" @click="handleAccordion(index)">
              <div
                class="mswcreators__content__faq__content__item__title__button"
                :class="{ active: faqs[index].isExpanded }"
              ></div>
              {{ faq.title }}
            </div>

            <Collapse :when="faqs[index].isExpanded" class="v-collapse">
              <!-- eslint-disable vue/no-v-html -->
              <div class="mswcreators__content__faq__content__item__description" v-html="faq.answer" />
            </Collapse>
          </div>
        </div>

        <div class="mswcreators__content__faq__actions">
          <ApplyBtn class="mswcreators__content__faq__actions__button" />
          <a
            :href="mswSite"
            target="_blank"
            class="mswcreators__content__faq__actions__button"
            @click="
              clickTracking({
                interaction: 'button_click',
                sectionNumber: 3,
                sectionName: 'FAQ',
                sectionContent: 'MSW Website',
              })
            "
            @click.middle="
              clickTracking({
                interaction: 'button_click',
                sectionNumber: 3,
                sectionName: 'FAQ',
                sectionContent: 'MSW Website',
              })
            "
            >MSW WEBSITE</a
          >
        </div>
      </div>
    </div>
    <Footer />
    <!-- Vuetify Dialog for alumni details -->
    <v-dialog v-model="alumniDialog">
      <template #default>
        <v-card class="alumni-dialog-card">
          <v-card-text class="alumni-dialog-content" :class="{ 'has-youtube': !!selectedAlumni?.youtube }">
            <div class="alumni-dialog-grid">
              <div class="alumni-dialog-avatar-title" style="grid-area: avatar">
                <img
                  class="alumni-avatar"
                  :src="getAlumniAvatarSrc(selectedAlumni?.title)"
                  :alt="selectedAlumni?.title + ' avatar'"
                />
                <span class="alumni-title">{{ selectedAlumni?.title }}</span>
              </div>
              <div v-if="selectedAlumni?.youtube" class="alumni-youtube-embed" style="grid-area: youtube">
                <iframe
                  :src="`https://www.youtube.com/embed/${selectedAlumni.youtube}`"
                  frameborder="0"
                  allowfullscreen
                  style="width: 100%; aspect-ratio: 16/9; border-radius: 0.7rem"
                ></iframe>
              </div>
              <div class="alumni-desc" style="grid-area: desc" v-html="selectedAlumni?.desc"></div>
              <div class="alumni-sign" style="grid-area: sign" v-text="selectedAlumni?.sign"></div>
              <a
                v-if="selectedAlumni?.url"
                :href="selectedAlumni.url"
                target="_blank"
                class="alumni-play-btn"
                style="grid-area: play"
              >
                <img src="@/assets/images/mswcreators/creators/play-icon.png" alt="Play icon" />
                Play
              </a>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import Responsive, { opts } from '@/services/browser/Responsive'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import { Collapse } from 'vue-collapsed'
import { useElementBounding, useWindowScroll, watchDebounced } from '@vueuse/core'
import '@/assets/scss/pages/mswcreators/index.scss'
// Vuetify components
import { VDialog, VCard, VCardText, VIcon } from 'vuetify/components'

export default defineComponent({
  name: 'MSWCreators',
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  components: {
    Collapse,
    VDialog,
    VCard,
    VCardText,
  },
  data() {
    return {
      loading: true,
      debounce: opts.debounce + 10,
      applyLink: 'https://www.research.net/r/QLL2LQ2',
      mswSite: 'https://maplestoryworlds.nexon.com/en/play',
      programKeys: [
        {
          title: 'Pitch, Design, and Publish your own games!',
          details:
            'Over the course of 12 weeks, the Workshop participants will pitch, design, and publish their own games in MapleStory Worlds.',
          showDetails: false,
        },
        {
          title: 'Enjoy roundtable game reviews and business coaching!',
          details:
            'Refine your project through roundtable peer review sessions and individualized business guidance from Nexon',
          showDetails: false,
        },
        {
          title: 'Receive creative, technical, and financial support from Nexon America!',
          details:
            'Program participants will receive creative and technical support from Nexon, business guidance, and a development fund.',
          showDetails: false,
        },
        {
          title: 'Active weekly sessions!',
          details: 'Workshop Creators are expected to actively participate in weekly feedback and coaching sessions.',
          showDetails: false,
        },
      ],
      showFaq: false,
      isExpanded: false,
      faqs: [
        {
          title: 'What is MapleStory Worlds?',
          answer:
            'MapleStory Worlds is a game development platform where anyone can enjoy fantastic Worlds that are created by Creators like you. With access to millions of assets from the world-renowned MMORPG MapleStory – including avatars, monsters, images, music, and more – you can jump into MapleStory Worlds and make a new World of your own. Learn more <a class="mswcreators__link" href="https://maplestoryworlds.nexon.com/en/about" target="_blank">here</a>',
          isExpanded: false,
        },
        {
          title: 'Can I submit more than one game idea?',
          answer:
            'You are welcome to develop more than one game idea for MapleStory Worlds, but only one game pitch per application will be reviewed. Your portfolio will be the best representation of your range and skills as a Creator.',
          isExpanded: false,
        },
        {
          title: 'When are applications due?',
          answer: 'Applications are due <strong>Aug 24, 2025 at 11:59PM PDT GMT-7.</strong>',
          isExpanded: false,
        },
        {
          title: 'What do I need to apply?',
          answer:
            'Applicants will need to submit their game pitch, game development and/or design portfolio, and resume.',
          isExpanded: false,
        },
        {
          title: 'When will I know if I’ve been selected?',
          answer:
            'The MapleStory Worlds team will reach out to selected candidates via email. Stay tuned in our <a class="mswcreators__link" target="_blank" href="https://discord.com/channels/1250259888869736572/1380687458303348887">#creator-programs-qna</a> Discord channel for updates. For any questions, feel free to post in our #creator-programs-qna Discord channel or email <a href="mailto:na_mswcreators@nexon.com" class="mswcreators__link">na_mswcreators@nexon.com</a>',
          isExpanded: false,
        },
        {
          title: 'What is the time commitment for this program?',
          answer:
            'Program participants will be required to attend a 1-hour roundtable feedback session each week. Outside of these meetings, the time required depends on the scope of your pitch.',
          isExpanded: false,
        },
        {
          title: 'I work for another game studio. Can I still apply?',
          answer:
            "Even if you are currently self-employed or employed at another game studio, you will be eligible to participate in this program. However, we encourage all program applicants to review their employment agreement and employer's policies before committing to the program.",
          isExpanded: false,
        },
        {
          title: 'What kinds of games are most successful on MapleStory Worlds?',
          answer:
            'As Creators on MapleStory Worlds, you define what lives on the platform. We encourage applicants to submit the game idea that you are most passionate about and reflects your strengths as a Creator.',
          isExpanded: false,
        },
        {
          title: 'Do I need to have employees to enter this program?',
          answer: 'Program participants do not need to have employees to participate in this program.',
          isExpanded: false,
        },
        {
          title: 'Do I need to have my own company to enter this program?',
          answer: 'Program participants do not need to own a company to participate in this program.',
          isExpanded: false,
        },
        {
          title: 'Can I submit more than one application?',
          answer:
            'Only one application per applicant will be reviewed. We encourage you to submit your strongest work in your application.',
          isExpanded: false,
        },
        {
          title: 'Can I submit as a team?',
          answer:
            'You are welcome to submit as a team. Please note that for the purposes of the development fund, projects that submit as a team will be considered as an individual participant.',
          isExpanded: false,
        },
        {
          title: "My question isn't here, is there someone I can speak to?",
          answer:
            'Please direct additional questions to our <a href="https://discord.com/channels/1250259888869736572/1380687458303348887" class="mswcreators__link" target="_blank">#creator-programs-qna</a> Discord channel.',
          isExpanded: false,
        },
        {
          title: 'I want to get involved, but I already have a project on MapleStory Worlds.',
          answer:
            'If you are interested in support for your launched project, apply for the Creator Circle! Creator Circle participants receive $3,500 monthly, priority technical support, and promotional support from Nexon for up to 12 months. <a href="https://www.research.net/r/Creatorscircle" target="_blank" class="mswcreators__link">Apply here</a>.<br/><br/>If you’ve launched a project and want support for a new concept, we’d love to see your application.<br/><br/>For other ways to get involved, check out our <a href="https://maplestoryworlds-creators.nexon.com/en/community/5479/5485/2665791" target="_blank" class="mswcreators__link">Creator News</a> or join our <a href="https://discord.gg/YansfK5gwC" target="_blank" class=mswcreators__link>Discord server</a>.',
          isExpanded: false,
        },
      ],
      activeMenuIndex: null,
      creatorWorkshopAlumni: [
        {
          title: 'Monster Royale',
          desc: `"As a long-time MapleStory player and aspiring game developer, MapleStory Worlds gave me the opportunity to finally bring my ideas to life. The ability to interact with other creators, exchange feedback, and see their progress was incredibly motivating.

What started as a MapleJam project evolved into Monster Royale, a game that challenged me to step out of my comfort zone. My motivation for joinign the workshop was to finish my project. While the learning curve was steep - the supportive community and hands-on experience helped me grow as a creator. The workshop wasn't just about building a game; it was about building relationships and skills that will last well beyond the program."`,
          sign: '- Renni from Custard, Monster Royale creator',
          url: 'https://maplestoryworlds.nexon.com/en/play/a2edcd3b29324c2f82bd6d6eea957816/',
          youtube: 'gqQPSXUIo9E',
        },
        {
          title: 'Maple Rogue',
          desc: `"The technical workshops were so valuable, and the regular pod meetings kept me motivated throughout the process.

The platform's pre-built systems, especially the attack animations and physics, saved months of development time compared to traditional game engines. Having access to MapleStory's iconic assets allowed me to create a polished game experience that would have been much more challenging to achieve elsewhere."`,
          sign: '- Peep, Maple Rogue creator',
          url: 'https://maplestoryworlds.nexon.com/en/play/c3585c2388294d10bd145d0d1f2fac1d/',
        },
        {
          title: 'Raidstory',
          desc: `"MapleStory Worlds is intuitive and easy to use, especially for Unity users. The documentation is pretty helpful - if you need to find a tool, a quick search on the API page will get you what you need. Playing with the tools and learning about them was fun, and the MapleStory Worlds team gave clear guidance on what to focus on. As a MapleStory player, I appreciated how accessible the platform was."`,
          sign: '- Tomqui, Raidstory creator',
          url: 'https://maplestoryworlds.nexon.com/en/play/ff5ac610777b42f598cd69372339d5d5/',
          youtube: 'oaY7EwnFjjA',
        },
        {
          title: 'A Place For Us',
          desc: `"I was immediately drawn to MapleStory Worlds’ extensive asset library and development capabilities. During the Creator Workshop, the support I received was incredible - from the operational and logistical guidance to the technical expertise. This support structure made the development process much smoother and kept me motivated throughout."

"Initially, I had ambitious plans to create a modern version of MapleStory with battle royale elements, but I realized I needed to start with something more focused. That's how 'A Place For Us' came to be. It was a strategic decision, considering the platform's potential for mobile accessibility and future growth."`,
          sign: '- EmberStream, A Place for Us creator',
          url: 'https://maplestoryworlds.nexon.com/en/play/dcb21616e8f54c48b3a5d4031ad1af4c/',
        },
        {
          title: 'Soulwood',
          desc: `“I discovered the workshop right after joining the Discord community. Since I was already interested in creating a game using MapleStory assets, the timing was perfect. The platform had quite a steep learning curve, so having the workshop's structured guidance was really motivating and helped me get started.

“The workshop was incredibly comprehensive - they guided us through everything from coding to valuable business. The individualized guidance was especially helpful since learning the platform from documentation alone would have taken hundreds of hours. Having this structured support while building our project saved us so much time compared to figuring everything out on our own."`,
          sign: '- Campout Studios, Soulwood creator',
          url: 'https://maplestoryworlds.nexon.com/en/play/109c4195f77c4972a5dbfd0ed1f2d803/',
        },
      ],
      alumniDialog: false,
      selectedAlumni: null,
    }
  },
  computed: {
    view() {
      return this.$store.state.viewType
    },
    isTabletMobile() {
      return this.view && ['tablet', 'mobile'].includes(this.view)
    },
  },
  watch: {
    loading() {
      this.$nextTick(() => {
        const { height: navHeight } = useElementBounding(this.$refs.refNav)
        const { y } = useWindowScroll()
        const refSections = []

        for (let n = 1; ; n++) {
          const ref = document.querySelector(`[data-section-number="${n}"]`)
          if (ref === null) break
          refSections.push(ref)
        }

        watchDebounced(
          y,
          () => {
            const scrollYPos = y.value + navHeight.value
            if (scrollYPos < refSections[0].offsetTop) {
              // header
              this.activeMenuIndex = -1
              return
            }
            for (let n = 0; n < refSections.length - 1; n++) {
              if (scrollYPos < refSections[n + 1].offsetTop) {
                this.activeMenuIndex = n
                return
              }
            }
            this.activeMenuIndex = refSections.length - 1
          },
          { debounce: 100, maxWait: 200 }
        )
      })
    },
  },
  mounted() {
    Responsive.init()

    setTimeout(() => {
      // wait for the responsive init
      this.loading = false

      dataLayer.push({
        pageType: 'MSW Creator Program',
      })
    }, this.debounce)
  },
  methods: {
    scrollToId(id, sectionContent) {
      this.$nextTick(() => {
        const visible = this.sectionVisibleOnNavClick()

        document.getElementById(id).scrollIntoView({
          behavior: 'smooth',
        })
        this.clickTracking({
          interaction: 'menu_click',
          sectionNumber: 0,
          sectionName: 'Header',
          sectionContent,
          specialValue: `${visible.index} - ${visible.name}`,
        })
      })
    },

    handleAccordion(selectedIndex) {
      this.faqs.forEach((_, index) => {
        this.faqs[index].isExpanded = index === selectedIndex ? !this.faqs[index].isExpanded : false
        if (this.faqs[index].isExpanded) this.isCollapsed(index + 1, this.faqs[index])
      })
    },
    handleMultiple(index) {
      this.faqs[index].isExpanded = !this.faqs[index].isExpanded
    },
    observeVisibilitySettings(id, name) {
      return {
        callback: (isVisible) => this.viewTracking(isVisible, { id, name }),
        intersection: { threshold: this.isTabletMobile ? 0.1 : 0.2 },
        throttle: 1000,
        once: true,
      }
    },
    viewTracking(isVisible, { id, name }) {
      if (isVisible) {
        dataLayer.push({
          event: 'standardMicrositeTrackingEvent',
          interaction: 'section_view',
          micrositeSectionNumber: id,
          micrositeSectionName: name,
        })
      }
    },
    clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
      dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: interaction,
        micrositeSectionNumber: sectionNumber,
        micrositeSectionName: sectionName,
        micrositeSectionContent: sectionContent,
        ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
      })
    },

    isCollapsed(index, item) {
      this.clickTracking({
        interaction: 'content_view',
        sectionNumber: 3,
        sectionName: 'FAQ',
        sectionContent: `${index} - ${item.title.slice(0, 20)}`,
      })
    },
    navbarIsSticky() {
      let hero = document.getElementById('hero')
      let heroHeight = hero.clientHeight
      if (heroHeight > 0) {
        return window.scrollY >= heroHeight - 45 ? true : false
      }
      return false
    },
    sectionInViewPort(id) {
      let myElement = document.getElementById(id)
      if (myElement) {
        let bounding = myElement.getBoundingClientRect()
        let navbarHeight = document.getElementById('navbar').clientHeight
        let myElementHeight = this.navbarIsSticky() ? myElement.offsetHeight - navbarHeight : myElement.offsetHeight
        let myElementWidth = myElement.offsetWidth

        if (
          bounding.top >= -myElementHeight &&
          bounding.left >= -myElementWidth &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight
        ) {
          return true
        }
      }
      return false
    },
    sectionVisibleOnNavClick() {
      let visibleIndex, visibleName, visibleId

      const sectionsId = [
        { id: 'hero', name: 'Hero' },
        { id: 'program-overview', name: 'Program Overview' },
        { id: 'curriculum', name: 'Curriculum' },
        { id: 'faq', name: 'FAQ' },
      ]
      sectionsId.find((element, index) => {
        if (this.sectionInViewPort(element.id)) {
          visibleIndex = index
          visibleName = element.name
          visibleId = element.id
          return true
        }
        return false
      })

      return {
        index: visibleIndex,
        name: visibleName,
        id: visibleId,
      }
    },
    navLinkClicked(tracking) {
      const visible = this.sectionVisibleOnNavClick()
      this.clickTracking({
        ...tracking,
        specialValue: `${visible.index} - ${visible.name}`,
      })
    },
    // Dynamically import all alumni images from creators folder (Vite only)
    getAlumniImageSrc(title) {
      // File name: lower case, spaces to hyphens, remove special chars, .webp extension
      const fileName =
        title
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9\-]/g, '') + '.webp'
      // Vite's import.meta.glob eager import
      if (!this._alumniImages) {
        // Only import once and cache
        this._alumniImages = import.meta.glob('@/assets/images/mswcreators/creators/*.webp', {
          eager: true,
          import: 'default',
        })
      }
      // The key must match the absolute path used by Vite
      const path = `/src/assets/images/mswcreators/creators/${fileName}`
      return this._alumniImages[path] || ''
    },
    openAlumniDialog(alumni) {
      this.selectedAlumni = alumni
      this.alumniDialog = true
    },
    getAlumniAvatarSrc(title) {
      // File name: lower case, spaces to hyphens, remove special chars, .webp extension (avatar images)
      const fileName =
        title
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9\-]/g, '') + '.webp'
      if (!this._alumniAvatars) {
        this._alumniAvatars = import.meta.glob('@/assets/images/mswcreators/creators/avatar/*.webp', {
          eager: true,
          import: 'default',
        })
      }
      const path = `/src/assets/images/mswcreators/creators/avatar/${fileName}`
      return this._alumniAvatars[path] || ''
    },
  },
})
</script>

<style lang="scss" scoped>
.v-collapse {
  transition: height var(--vc-auto-duration) ease-out;
}
// Thumbnail grid styles
.contents {
  display: flex;
  flex-wrap: wrap;
  gap: 32px 4%; // vertical, horizontal gap
  justify-content: center;
}
.thumbnail-frame {
  width: 48%; // two per row with gap
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.thumbnail-frame img {
  width: 100%;
  // aspect-ratio: 1/1;
  object-fit: cover;
  border: 5px solid white;
  border-radius: 2rem; // circle crop
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: #f5f5f5;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s, border-color 0.3s;
}
.thumbnail-frame img:hover {
  transform: scale(1.06);
  box-shadow: 0 8px 40px 0 rgba(30, 41, 59, 0.32), 0 1.5px 8px 0 rgba(30, 41, 59, 0.18);
  border-color: #e0e7ff;
}
.mobile,
.tablet {
  .thumbnail-frame {
    width: 100%;
    img {
      border-radius: 1.5rem;
    }
  }
}

.alumni-dialog-card {
  padding: 0;
  border-radius: 1rem !important;
  overflow: hidden;
}
.alumni-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
}
.alumni-dialog-avatar-title {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.alumni-avatar {
  width: 56px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.alumni-title {
  font-size: 2rem;
  // font-weight: 700;
  color: #29486a;
  font-family: 'SignikaNegative-bold';
}
.alumni-dialog-content {
  padding-top: 0;
}
.alumni-dialog-flex {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}
.alumni-dialog-left {
  flex: 1 1 340px;
  min-width: 320px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.alumni-play-btn {
  display: inline-flex;
  width: 100%;
  max-width: 20rem;
  height: 59px;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  background: #fd7e23;
  color: #fff;
  font-family: 'SignikaNegative-bold';
  // font-size: 1.2rem;
  border-radius: 8px;
  // padding: 0.6rem 2.2rem;
  margin: 0 auto 2rem;
  text-decoration: none;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  img {
    scale: 0.7;
    margin-top: -2px;
  }
}
.alumni-play-btn:hover {
  background: #d8631b;
}
.alumni-dialog-right {
  flex: 2 1 340px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.alumni-desc {
  white-space: pre-line;
  // margin-top: 0.5rem;
  font-size: 1.2rem;
  color: #29486a;
  font-family: 'SignikaNegative-Medium';
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.alumni-sign {
  font-family: 'SignikaNegative-bold';
  font-size: 1.2rem;
  color: #29486a;
}

:deep(.v-overlay__content) {
  margin-left: 5vw;
  margin-right: 5vw;
  width: auto;
}

@media (max-width: 1024px) {
  :deep(.v-overlay__content) {
    margin-left: 1vw;
    margin-right: 1vw;
  }
  :deep(.v-card) {
    .v-card-text {
      padding: 0 1.5rem !important;
    }
  }
}

.alumni-dialog-content.has-youtube .alumni-dialog-grid {
  display: grid;
  grid-template-areas:
    'avatar desc'
    'youtube desc'
    'play sign';
  grid-template-columns: 1.5fr 2fr;
  grid-template-rows: auto 1fr auto;
  gap: 1.5rem 2rem;
  align-items: start;
}
.alumni-dialog-content:not(.has-youtube) .alumni-dialog-grid {
  display: grid;
  grid-template-areas:
    'avatar'
    'desc'
    'sign'
    'play';
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto auto;
  gap: 1.2rem 0;
  justify-items: center;
  text-align: center;
}
.alumni-dialog-avatar-title {
  justify-content: center;
  align-items: center;
  gap: 1rem;
  display: flex;
  margin-top: 2rem;
}

.mobile,
.tablet {
  .alumni-dialog-content {
    .alumni-dialog-grid {
      grid-template-areas:
        'avatar'
        'desc'
        'sign'
        'youtube'
        'play';
      grid-template-columns: 1fr;
    }
    .alumni-desc,
    .alumni-sign {
      font-size: 0.9rem;
    }
  }
}
</style>
